import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'
import homeView from '../views/homeView.vue'
import hkcmaView from '../views/hkcmaView.vue'
import hkkfView from '../views/hkkfView.vue'
import alconView from '../views/alconView.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: homeView
  },
  {
    path: '/2026CDD',
    name: '2026CDD',
    component: hkcmaView
  },
  {
    path: '/hkkf',
    name: 'hkkf',
    component: hkkfView
  },
  {
    path: '/alcon',
    name: 'alcon',
    component: alconView
  },
  {
    path: '/hkkf/froms',
    name: 'hkkffroms',
    component: () => import(/* webpackChunkName: "about" */ '../views/hkkfFromsView.vue')
  },
  {
    path: '/hkkf/exportUsers',
    name: 'hkkfexportUsers',
    component: () => import(/* webpackChunkName: "about" */ '../views/hkkfExportUsers.vue')
  },
  {
    path: '/alcon/froms',
    name: 'alconfroms',
    component: () => import(/* webpackChunkName: "about" */ '../views/alconFromsView.vue')
  },
  {
    path: '/alcon/exportUsers',
    name: 'alconexportUsers',
    component: () => import(/* webpackChunkName: "about" */ '../views/alconExportUsers.vue')
  },
  // {
  //   path: '/hkcma/photo',
  //   name: 'hkcmaPhoto',
  //   component: () => import(/* webpackChunkName: "about" */ '../views/hkcmaPhotoView.vue')
  // },
  // {
  //   path: '/hkcma/organisers',
  //   name: 'hkcmaorganisers',
  //   component: () => import(/* webpackChunkName: "about" */ '../views/hkcmaOrganisersView.vue')
  // },
  // {
  //   path: '/hkcma/DoctorTypes',
  //   name: 'hkcmaDoctorsTypes',
  //   component: () => import(/* webpackChunkName: "about" */ '../views/hkcmaDoctorsTypesView.vue')
  // },
  {
    path: '/2026CDD/froms',
    name: 'hkcmafroms',
    component: () => import(/* webpackChunkName: "about" */ '../views/hkcmaFromsView.vue')
  },
  {
    path: '/2026CDD/exportUsers',
    name: 'hkcmaexportUsers',
    component: () => import(/* webpackChunkName: "about" */ '../views/hkcmaExportUsers.vue')
  },
  // {
  //   path: '/hkcma/importUsers',
  //   name: 'hkcmaImportUsers',
  //   component: () => import(/* webpackChunkName: "about" */ '../views/hkcmaImportUsers.vue')
  // }
  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  // }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
